
<div *ngFor="let comment of comments; let i = index" class="comment-row">

    <ng-container *ngIf="showEditComment(comment)">
        <div class="comment-body" [ngClass]="{'bottom-border': comments.length > 1}">
            <div class="comment-content">
                <mat-form-field appearance="fill" class="width-max style-2">
                    <mat-label *ngIf="textareaLabel">{{ textareaLabel }}</mat-label>
                    <textarea matInput *ngIf="isAutoSave" [(ngModel)]="comment.message" [ngModelOptions]="{debounce: 1000}" (change)="saveComment(comment)"
                        class="hidden-print" rows="5" ></textarea>
                    <textarea matInput *ngIf="!isAutoSave" [(ngModel)]="comment.message" class="hidden-print" rows="5"></textarea>
                </mat-form-field>
            </div>
            <div class="comment-actions" *ngIf="isShowDeleteButton && isAllowDelete(comment)">
                <button mat-flat-button color="accent" (click)="$event.stopPropagation(); deleteComment(comment)" title="Hozzászólás törlése">
                    <mat-icon class="normal no-margin">delete</mat-icon>
                </button>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!showEditComment(comment) && comment.message">
        <div class="comment-header" *ngIf="isCommentHeaderVisible" [ngClass]="{'style-3': displayStyle === 'style-3'}">
            <div class="comment-author">{{ comment.author }}</div>
            <div class="comment-date" *ngIf="comment.createdOn">Létrehozva: {{ comment.createdOn | localizedDate:"datetime" }} <span *ngIf="comment.updatedOn">| Módosítva: {{ comment.updatedOn | localizedDate:"datetime" }}</span></div>
        </div>
        <div class="comment-body" [ngClass]="{'bottom-border': comments.length > 1}">
            <div class="comment-content"><span [ngClass]="{'comment-readonly': displayStyle === 'style-1'}">{{ comment.message }}</span></div>
            <div class="comment-actions" *ngIf="isShowDeleteButton && isAllowDelete(comment)">
                <button mat-flat-button color="accent" (click)="$event.stopPropagation(); deleteComment(comment)" title="Hozzászólás törlése">
                    <mat-icon class="normal no-margin" >add</mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</div>
